import { render } from "./integrations.vue?vue&type=template&id=2bfeeb9f&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=2bfeeb9f&scoped=true&lang=css&external"
import "./integrations.vue?vue&type=style&index=1&id=2bfeeb9f&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfeeb9f"]])

export default __exports__